import ApiService from "@/utils/api.service";

function validateField(context, params) {
    let block = context.state.blocks.find(block => block.id == params.blockId);
    if (block) {
        context.commit("resetFieldError", params);
        if (block.fieldObject.required === 1 && (!block.data || !block.data.value)) {
            context.commit("addFieldError", { blockId: params.blockId, errorMessage: "Champ obligatoire" });
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}


export default {
    load(context, order) {
        context.commit('setOrder', order);
    },
    clean(context) {
        context.commit('cleanOrder');
    },
    addError(context,params){
        context.commit("addFieldError", { blockId: params.blockId, errorMessage: params.message});
    },

    validateField(context, params) {
        let block = context.state.blocks.find(block => block.id == params.blockId);
        if (block) {
            context.commit("resetFieldError", params);
            console.log("validateField", block.fieldObject.name, block.data.value);
            if (block.fieldObject.required === 1 && !block.data.value) {
                block.isValid = false;
                context.commit("addFieldError", { blockId: params.blockId, errorMessage: "Champ obligatoire" })
            } else {
                block.isValid = true;
            }
            return block.isValid;
        } else {
            return false;
        }
    },

    updateField(context, params) {

        context.commit("updateField", params);

        let valid = validateField(context, params);

        console.log("updateField::valid", valid);

        if (context.state.hasUpdate === true && valid == true) {
            context.dispatch("saveField", params);
        }

        context.commit("setHasUpdate", false);
    },

    updateFieldValidationStatus(context, params) {
        context.commit("updateFieldValidationStatus", params);
    },
    validateStep(context) {
        let stepValid = true;
        for (let index = 0; index < context.getters.currentStep.blocks.length; index++) {
            const block = context.state.blocks[index];

            if (!validateField(context, { blockId: block.id })) {
                stepValid = false;
            }
        }
        context.commit("setStepValidation", stepValid);
    },
    nextStep(context) {
        context.dispatch('validateStep').then(() => {
            context.commit("nextStep");
        });
    },
    prevStep(context) {
        context.commit("prevStep");
    },
    saveField(context, params) {
        if (params.blockId) {
            return new Promise(resolve => {
                ApiService.put("order/" + context.state.order.id,
                    {
                        datas: [
                            {
                                id: params.blockId,
                                value: params.value
                            }
                        ]
                    }).
                    then(({ data }) => {
                        context.commit("updateOrder", data)
                        resolve(data);
                    })
            })
        }
    },
    submit(context) {
        return new Promise(() => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("order/" + context.state.order.id + "/validation").then(() => {
                context.commit("setOrderMode", "thanks");
            })
                .catch(error => {
                    if (error.response) {
                        alert(error.response.data.error);
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        console.log("Error", error.message);
                    }
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    updateRef(context) {

        return new Promise(resolve => {
            ApiService.put("order/" + context.state.order.id,
                {
                    ref: context.state.order.ref
                }).
                then(({ data }) => {
                    resolve(data);
                })
        })
    },
}
